import { render, staticRenderFns } from "./TeamMemberSearchBar.vue?vue&type=template&id=74cf07d1&"
import script from "./TeamMemberSearchBar.vue?vue&type=script&lang=js&"
export * from "./TeamMemberSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Times: require('/vercel/path0/components/icons/Times.vue').default})
